/* eslint-disable */

import { observable, action, computed } from 'mobx';
import { hashHistory } from 'react-router';
window.hashHistory = hashHistory;
import { toast, ruleToast } from 'utils/notification';
import * as TextService from 'services/TextService';
import dashboardStore from './1212Store';
import scrollToAnchor from 'utils/scrollToAnchor';
import { transformNumber, transformString } from 'utils/transformType';
const { Time, Verify, Account, Dashi, Group, Share, URL } = window.$ACE;
const templateId = 12;

/**
 * 基本信息Store
 */
class GroupInfoStore {
  @observable
  paidCount = 0; // 当前团拉新人数

  @observable
  loading = false; // 分享过程中等待

  @observable
  userNick = ''; // 分享页拿到分享者的昵称

  @computed
  get rewardForPaidCount() {
    // 根据拉新人数计算奖励的云服务器以及云数据库月数
    const count = this.paidCount;
    let reward = {};
    if (count == 1) {
      reward = {
        ecs: 3,
        sql: 0,
      };
    } else if (count == 2) {
      reward = {
        ecs: 4,
        sql: 0,
      };
    } else if (count == 3) {
      reward = {
        ecs: 5,
        sql: 0,
      };
    } else if (count == 4) {
      reward = {
        ecs: 6,
        sql: 0,
      };
    } else if (count == 5) {
      reward = {
        ecs: 12,
        sql: 0,
      };
    } else if (count == 6) {
      reward = {
        ecs: 12,
        sql: 3,
      };
    } else if (count >= 7) {
      reward = {
        ecs: 12,
        sql: 6,
      };
    } else {
      reward = {
        ecs: 0,
        sql: 0,
      };
    }
    return reward;
  }

  // 开团 开团会判断是否是云大使
  @action
  openTeam = async (changeState, loading) => {
    if (loading) {
      return;
    }
    changeState && changeState(true);
    if (!dashboardStore.isLogin) {
      changeState && changeState(false);
      return toast({ type: 'notLoginError' });
    } else {
      // if (dashboardStore.isNewUser) {
      //   changeState && changeState(false);
      //   return toast({ type: 'remind' });
      // }
    }
    return this.createTeam(changeState);
  };

  @action
  createTeam = async changeState => {
    const { status, data, msg, errorCode } = await Group.open(templateId);
    // 开团成功 status为true，从data获取字段；开团失败，status为false，从msg获取错误信文案
    if (status) {
      dashboardStore.groupCode = data.groupCode;
      // 开团成功之后，重新捞一下团信息数据
      changeState && changeState(false);
      await this.fetchGroupInfo(dashboardStore.groupCode);
      scrollToAnchor('my-info');
    } else {
      changeState && changeState(false);
      toast({
        type: errorCode,
      });
      // console.log(msg, errorCode, '开团接口');
    }
  };

  // 开团之后查询团信息
  @action
  fetchGroupInfo = async groupCode => {
    const groupInfo = await Group.getGroupDetail(groupCode);
    // this.groupMembers = groupInfo.members
    // console.log('团信息为', groupInfo);
    if (!groupInfo && dashboardStore.isShare) {
      // 打开错误的分享的团链接直接跳转到首页
      return (location.href = `${location.origin}${location.pathname}`);
    }
    this.paidCount = groupInfo.paidCount;
    // console.log('当前用户拉新人数', this.paidCount);
    this.userNick = groupInfo.teamLeader.userNick.substring(0, 25); //名字截取最长25个字符
  };

  // 页面加载时获取团信息
  @action
  getGroupInfo = async () => {
    const { open } = await Group.getUserGroup(templateId);
    if (open) {
      // console.log('有过开团记录');
      dashboardStore.groupCode = open;
      await this.fetchGroupInfo(dashboardStore.groupCode);
    } else {
      dashboardStore.groupCode = null;
    }
  };
  @action
  shareOut = async (type, shareUrl, changeCopyVisible) => {
    // const { title, content, img } = this.props.textStore.share;
    const { shareText } = dashboardStore.homeData12.pcData;
    const shareInstance = Share.create({
      ...shareText,
    });
    const PC = shareInstance.createPC();
    const H5 = await shareInstance.createH5();
    const shareLink = {
      url: shareUrl,
    };
    if (window.isMobile) {
      H5.share(shareLink);
      return;
    }
    if (type == 'weibo') {
      let weiboUrl = await PC.weibo(shareLink);
      window.open(weiboUrl);
    } else if (type == 'qq') {
      let qqUrl = await PC.qq(shareLink);
      window.open(qqUrl);
    } else if (type == 'qr') {
      return;
    } else if (type == 'copy') {
      await PC.copyLink(shareLink);
      changeCopyVisible(true);
      setTimeout(() => {
        changeCopyVisible(false);
      }, 2000);
      return;
    }
  };

  @action
  openYundashiRule = async () => {
    await TextService.fetchyundashiRule();
  };
}
let groupInfoStore = new GroupInfoStore();
export default groupInfoStore;



// WEBPACK FOOTER //
// ./src/scripts/stores/groupInfoStore.js